var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("default-item", {
    staticClass: "menu--item-back_bar_default",
    attrs: {
      item: _vm.itemFormatted,
      layout: "price-inline",
      "tag-location": "before-title",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }